import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";

export const QuantitySelector = ({ item, remove, add }) => {
  const quantity = parseInt(item.quantity, 10) || 0;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        borderRadius: 2,
        p: 1,
      }}
    >
      <IconButton size="xs" sx={{ p: 0.5 }} onClick={() => remove(item)}>
        <Remove fontSize="small" />
      </IconButton>
      <Typography variant="body2" p={1}>
        {quantity}
      </Typography>
      <IconButton sx={{ p: 0.5 }} onClick={() => add(item)}>
        <Add fontSize="small" />
      </IconButton>
    </Box>
  );
};
